import React from 'react';
import { useSelector } from 'react-redux';
import ReactMarkdown from 'react-markdown';
import styled from 'styled-components';
import { RootState } from '../../state/store';

const MaintenanceBanner: React.FC = () => {
  const { company_details } = useSelector((state: RootState) => state.company);
  const maintenanceMode = company_details?.maintenance_mode?.enabled;
  const message = company_details?.maintenance_mode?.message;

  if (!maintenanceMode) {
    return null;
  }

  return (
    <Banner>
      <ReactMarkdown components={{
        p: ({ children }) => <p style={{ margin: 0 }}>{children}</p>,
      }}>{message}</ReactMarkdown>
    </Banner>
  );
};

export default MaintenanceBanner;

const Banner = styled.div`
  position: fixed;
  top: 0;
  background: linear-gradient(90deg, #3B4C99 0%, #6C0E6E 100%);
  color: white;
  font-size: 14px;
  padding: 10px 60px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 60px;
  z-index: 500;
`;
